import { convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import React from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { useSelector } from 'react-redux';
import { parseText } from '../../../../../utils/templates.js';
import { Row, Col } from '../../../../Grid/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { usePropertyTypes } from '@debbie/cortex/dist/properties/index.js';
import { getMentionSuggestions } from '@debbie/common/dist/templates/suggestions.js';
import { TemplateType } from '@debbie/common/dist/templates/index.js';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors.js';
const BPDescInput = (props) => {
    const lang = useSelector((s) => s.lang);
    const tenant = useSelector(selectTenant);
    const propertyTypesLoadable = usePropertyTypes();
    const propertyTypes = h.hasData(propertyTypesLoadable)
        ? propertyTypesLoadable.data
        : undefined;
    const mentionSuggestions = getMentionSuggestions(lang, TemplateType.LETTER, propertyTypes || undefined, tenant);
    const setBPDesc = (editorState) => {
        const bpDesc = parseText(draftToHtml(convertToRaw(editorState.getCurrentContent())), mentionSuggestions);
        props.setDocumentState({ bpDesc });
    };
    return (React.createElement(Row, null,
        React.createElement(Col, { width: "12" },
            React.createElement("h3", null, "Rubrik 5"),
            React.createElement(Editor, { stripPastedStyles: true, editorState: props.editorState, onEditorStateChange: (editorState) => {
                    props.setEditorState(editorState);
                    setBPDesc(editorState);
                }, mention: {
                    separator: ' ',
                    trigger: '@',
                    suggestions: mentionSuggestions.map((suggestion) => ({
                        value: suggestion.label,
                        text: suggestion.label,
                        url: suggestion.label,
                    })),
                } }))));
};
export default BPDescInput;
//# sourceMappingURL=BPDescInput.js.map